// extracted by mini-css-extract-plugin
export default {"player":"AmSFM"};